import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  ProjectHoursBillingByPicker,
  ProjectHoursBillingByPickerProps,
} from '@work4all/components/lib/components/entity-picker/project-hours-billing-by-picker/ProjectHoursBillingByPicker';

import { ProjectHoursBillingBy } from '@work4all/models/lib/Enums/ProjectHoursBillingBy.enum';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<
    ProjectHoursBillingByPickerProps<false>,
    'multiple' | 'value' | 'onChange'
  > {
  error?: string;
  value: ProjectHoursBillingBy;
  onChange: (value: ProjectHoursBillingBy) => void;
}

export const ProjectHoursBillingByPickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const name = t(`PROJECT_HOURS_BILLING_BY.${value}`);

  return (
    <EntityPickerPopover
      picker={
        <ProjectHoursBillingByPicker
          {...pickerProps}
          multiple={false}
          value={{ id: value, name: name }}
          onChange={(value) => onChange(value.id)}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        label={t('COMMON.ONE_RECEIPT_PER')}
        error={error}
        value={name}
      />
    </EntityPickerPopover>
  );
});
